import { render, staticRenderFns } from "./SignInAlertModal.vue?vue&type=template&id=5631e53f&scoped=true&"
import script from "./SignInAlertModal.vue?vue&type=script&lang=ts&"
export * from "./SignInAlertModal.vue?vue&type=script&lang=ts&"
import style0 from "./SignInAlertModal.vue?vue&type=style&index=0&id=5631e53f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5631e53f",
  null
  
)

export default component.exports